import React, { Component } from 'react';

import './HoveredImage.scss';

class HoveredImage extends Component {

	constructor(props) {
        super(props);

        this.state = {
            imageClass: ''
        }

        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
	}

    mouseEnter() {
        console.log('mouse enter')
        this.setState({ imageClass: 'hovered_image_hover' });
    }

    mouseLeave() {
        console.log('mouse leave')
        this.setState({ imageClass: '' });
    }

	render() {
		var classItem = [
			'hovered_image',
            this.state.imageClass
		];

        return (
        	<div
                className={ classItem.join(' ') }
                onMouseEnter={ this.mouseEnter }
                onMouseLeave={ this.mouseLeave }>
                <img src={ this.props.image1 } className="image1" />
                <img src={ this.props.image2 } className="image2" />
            </div>
    	);
	}
}

export { HoveredImage };